module.exports = __webpack_public_path__ + "img/driving-deepper.dea49a1a.svg";